import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { getRandom } from "tsparticles-engine";
import { updateSize } from "./Utils";
export var SizeUpdater = /*#__PURE__*/function () {
  function SizeUpdater() {
    _classCallCheck(this, SizeUpdater);
  }

  _createClass(SizeUpdater, [{
    key: "init",
    value: function init(particle) {
      var container = particle.container,
          sizeOptions = particle.options.size,
          sizeAnimation = sizeOptions.animation;

      if (sizeAnimation.enable) {
        var _particle$retina$size;

        particle.size.velocity = ((_particle$retina$size = particle.retina.sizeAnimationSpeed) !== null && _particle$retina$size !== void 0 ? _particle$retina$size : container.retina.sizeAnimationSpeed) / 100 * container.retina.reduceFactor;

        if (!sizeAnimation.sync) {
          particle.size.velocity *= getRandom();
        }
      }
    }
  }, {
    key: "isEnabled",
    value: function isEnabled(particle) {
      var _particle$size$maxLoo, _particle$size$maxLoo2, _particle$size$loops, _particle$size$maxLoo3;

      return !particle.destroyed && !particle.spawning && particle.size.enable && (((_particle$size$maxLoo = particle.size.maxLoops) !== null && _particle$size$maxLoo !== void 0 ? _particle$size$maxLoo : 0) <= 0 || ((_particle$size$maxLoo2 = particle.size.maxLoops) !== null && _particle$size$maxLoo2 !== void 0 ? _particle$size$maxLoo2 : 0) > 0 && ((_particle$size$loops = particle.size.loops) !== null && _particle$size$loops !== void 0 ? _particle$size$loops : 0) < ((_particle$size$maxLoo3 = particle.size.maxLoops) !== null && _particle$size$maxLoo3 !== void 0 ? _particle$size$maxLoo3 : 0));
    }
  }, {
    key: "reset",
    value: function reset(particle) {
      particle.size.loops = 0;
    }
  }, {
    key: "update",
    value: function update(particle, delta) {
      if (!this.isEnabled(particle)) {
        return;
      }

      updateSize(particle, delta);
    }
  }]);

  return SizeUpdater;
}();